<template>
  <div>
    <Pos_promotion_create/>
  </div>
</template>

<script>
import Pos_promotion_create from "@/components/adminArin/pos_system/warehouse/inventory/Pos_promotion_create";
export default {
  name: "PosPromotionCreate",
  components: {
    Pos_promotion_create
  }
}
</script>

<style scoped>

</style>
